import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import TitlePage from './TitlePage';
import { ManuscriptArea } from './ManuscriptArea';
import useThemeStyles from '../../../../../hooks/useThemeStyles';

const ManuscriptCenter = ({
  activeProject = null,
  chapters,
  showTitlePage = false,
  rightSidebarOpen = true,
  onChapterClick = null,
  onSceneAdded,
  onAddScene,
  suppressSceneLoading = false,
}) => {
  const { colors, isDark } = useThemeStyles();
  const totalWordCount = chapters.reduce((total, chapter) => {
    return total + (chapter.wordCount || 0);
  }, 0);

  if (showTitlePage) {
    return (
      <TitlePage
        title={activeProject?.title || 'Untitled Project'}
        wordCount={totalWordCount}
        pseudonym={activeProject?.pseudonym || 'Anonymous'}
      />
    );
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        id="manuscript-scroll-container"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          p: 3,
          position: 'relative',
          backgroundColor: isDark ? '#0f172a' : colors?.background?.primary || '#ffffff',
          backgroundImage: isDark
            ? `radial-gradient(ellipse at center, rgba(30, 41, 59, 0.3) 0%, rgba(15, 23, 42, 0.6) 50%, rgba(15, 23, 42, 0.9) 100%),
               linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)`
            : 'none',
          '&::before': !rightSidebarOpen
            ? {
                content: '""',
                display: 'block',
                height: '50px',
                width: '100%',
              }
            : {},
        }}
      >
        <TitlePage
          title={activeProject?.title || 'Untitled Project'}
          wordCount={totalWordCount}
          pseudonym={activeProject?.pseudonym || 'Anonymous'}
        />
        <ManuscriptArea
          chapters={chapters}
          onChapterClick={onChapterClick}
          showTitlePage={showTitlePage}
          activeProject={activeProject}
          onSceneAdded={onSceneAdded}
          onAddScene={onAddScene}
          suppressSceneLoading={suppressSceneLoading}
        />
      </Box>
    </Box>
  );
};

export default ManuscriptCenter;

/* eslint-disable react/require-default-props */
ManuscriptCenter.propTypes = {
  activeProject: PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    pseudonym: PropTypes.string,
    type: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    thinOwner: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    }),
  }),
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      wordCount: PropTypes.number,
    })
  ).isRequired,
  showTitlePage: PropTypes.bool,
  rightSidebarOpen: PropTypes.bool,
  onChapterClick: PropTypes.func,
  onSceneAdded: PropTypes.func,
  onAddScene: PropTypes.func,
  suppressSceneLoading: PropTypes.bool,
};
/* eslint-enable react/require-default-props */
